export const validateForm = () => {
    const errors: Record<string, string> = {};

    const validateField = ({ name, message }: { name: string; message: string | undefined }) => {
        if (message && !errors[name]) {
            errors[name] = message;
        }
    };

    return { validateField, errors };
};
